import { useState } from 'react';

import SvgIcon from '@lcsc-ui/components/SvgIcon';
import useUserStore from '@lcsc-ui/store/user';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';

const CusServicePop = ({ qrCodeSrc }) => {
  const { commonConfigVO } = useUserStore();
  const [showC, setShowC] = useState(false);
  function _loadWx() {
    buriedPoint({
      cp: 'top_header',
      ty: 'click',
      op: 'qq_click_wx',
      data: { hf: 'https://work.weixin.qq.com/kfid/kfc5deddba351c362c2' },
    });

    const name = 'wxWindow';
    const iHeight = 600;
    const iWidth = 750;

    const iTop = (window.screen.height - 30 - iHeight) / 2; //获得窗口的垂直位置;
    const iLeft = (window.screen.width - 10 - iWidth) / 2; //获得窗口的水平位置;

    window.open(
      'https://work.weixin.qq.com/kfid/kfc5deddba351c362c2',
      name,
      'height=' +
        iHeight +
        ',innerHeight=' +
        iHeight +
        ',width=' +
        iWidth +
        ',innerWidth=' +
        iWidth +
        ',top=' +
        iTop +
        ',left=' +
        iLeft +
        ',toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no'
    );
  }
  function _loadQq() {
    buriedPoint({
      cp: 'top_header',
      ty: 'click',
      op: 'qq_click_kf',
      data: { hf: 'https://wpa1.qq.com/zohvG78r?_type=wpa&qidian=true' },
    });

    const name = 'qqWindow';
    const iHeight = 600;
    const iWidth = 750;
    const iTop = (window.screen.height - 30 - iHeight) / 2; //获得窗口的垂直位置;
    const iLeft = (window.screen.width - 10 - iWidth) / 2; //获得窗口的水平位置;
    window.open(
      'https://wpa1.qq.com/zohvG78r?_type=wpa&qidian=true',
      name,
      'height=' +
        iHeight +
        ',innerHeight=' +
        iHeight +
        ',width=' +
        iWidth +
        ',innerWidth=' +
        iWidth +
        ',top=' +
        iTop +
        ',left=' +
        iLeft +
        ',toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no'
    );
  }

  function handleTs() {
    if (!showC) {
      buriedPoint({
        cp: 'top_header',
        ty: 'click',
        op: 'member_complain',
      });
    }
    setShowC(!showC);
  }
  return (
    <section className="px-[13px] py-[10px] w-[164px]">
      <section className="text-[12px] pb-[10px]">
        <h3 className="text-[#666] leading-[19px] mb-[10px]">在线客服</h3>
        <ul className="list-none flex flex-col justify-between">
          <li
            className="flex custom-group items-center mb-[12px] hover:text-lcBlue cursor-pointer"
            title="点击联系微信客服"
            onClick={_loadWx}
          >
            <SvgIcon app="common" iconName="wx" className="size-[24px]" />
            <p className="ml-[10px]">
              <span>微信咨询</span>
              <SvgIcon
                app="common"
                iconName="arrow-hover"
                className="ml-[7px] hidden custom-group-hover-inline-block size-[8px]"
              />
            </p>
          </li>
          <li
            className="flex custom-group items-center mb-[12px] hover:text-lcBlue cursor-pointer"
            title="点击联系QQ在线客服"
            onClick={_loadQq}
          >
            <SvgIcon app="common" iconName="qq" className="size-[24px]" />
            <p className="ml-[10px]">
              <span>QQ咨询</span>
              <SvgIcon
                app="common"
                iconName="arrow-hover"
                className="ml-[7px] hidden custom-group-hover-inline-block size-[8px]"
              />
            </p>
          </li>
          <li className="flex items-center mb-[12px]">
            <SvgIcon app="common" iconName="tel" className="size-[24px]" />
            <p className="ml-[10px]">{commonConfigVO?.salesmanVO?.phoneNo || '0755-83865666'}</p>
          </li>
          <li>
            <section className="flex items-center mb-[4px]">
              <SvgIcon app="common" iconName="gzh" className="size-[24px]" />
              <p className="ml-[10px]">公众号咨询</p>
            </section>
            <section className="pl-[34px]">
              {!qrCodeSrc ? (
                <img
                  src="https://static.szlcsc.com/ecp/assets/newWeb/toolbar/gzh.png"
                  title="微信快捷咨询"
                  className="size-[86px] mb-[7px]"
                  alt="微信快捷咨询"
                />
              ) : (
                <img
                  src={qrCodeSrc}
                  title="扫码咨询客服"
                  alt="扫码咨询客服"
                  className="size-[86px] mb-[7px]"
                  onError={(event) => {
                    event.target.src = 'https://static.szlcsc.com/ecp/assets/newWeb/toolbar/gzh.png';
                  }}
                />
              )}
              <p className="leading-[20px] inline-block text-[#999]">工作日8:30-20:30</p>
              <p className="leading-[20px] inline-block text-[#999]">节假日8:30-18:00</p>
            </section>
          </li>
        </ul>
      </section>
      <button className="text-[#666] custom-group text-[12px] hover:text-lcBlue" onClick={handleTs}>
        我要投诉
        <SvgIcon
          app="common"
          iconName="arrow"
          className={`ml-[7px] size-[8px] transition-transform custom-group-hover-hidden inline-block duration-100 ${showC ? 'rotate-90' : ''}`}
        />
        <SvgIcon
          app="common"
          iconName="arrow-hover"
          className={`ml-[7px] size-[8px] transition-transform hidden custom-group-hover-inline-block duration-100 ${showC ? 'rotate-90' : ''}`}
        />
      </button>
      {showC && (
        <section className="text-[12px] mt-[10px]">
          <ul className="list-none flex flex-col justify-between">
            <li>
              <section className="flex items-center mb-[4px]">
                <SvgIcon app="common" iconName="tel" className="size-[24px]" />
                <p className="ml-[10px]">18165707450</p>
              </section>
              <section className="pl-[34px]">
                <img
                  src="https://static.szlcsc.com/ecp/assets/web/layout/tools/images/righ_utils_icon_tsyj_qrcode_new.png"
                  title="此意见箱直通管理层"
                  alt="扫码投诉"
                  className="size-[86px] mb-[7px]"
                />
                <p className="leading-[20px] inline-block text-[#999]">工作日9:00-18:00</p>
              </section>
            </li>
          </ul>
        </section>
      )}
    </section>
  );
};

export default CusServicePop;
